import React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

export default function ShareEmailsAutocomplete({
  shareEmails,
  id = 'emails',
  label = 'Send Email To',
  helperText = 'Enter email(s). Press Enter to add, or click Share',
}) {
  const {
    emails,
    emailInput,
    onInputChange,
    onChange,
    preventEnterSubmit,
  } = shareEmails

  return (
    <Autocomplete
      multiple
      id={id}
      options={[]}
      value={emails}
      inputValue={emailInput}
      onInputChange={onInputChange}
      onChange={onChange}
      freeSolo
      autoSelect
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder="Emails"
          helperText={helperText}
          onKeyDown={preventEnterSubmit(params)}
        />
      )}
    />
  )
}
